module.exports = __webpack_public_path__ + "static/how-item-2.5b08236d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/How/how-item-2.png
// module id = 138
// module chunks = 1135276415346 35783957827783